import { Component, Input } from '@angular/core';
import { BillingStrategy } from '@galaxy/billing';
import { OrderConfirmationItem } from '../../../confirmation-page/interface';
import { AppIdToEditionIdToEditionMap, isValidEditionId } from '../../../core/interface';

@Component({
  selector: 'app-order-form-apps-custom-price',
  templateUrl: './apps-custom-price.component.html',
  styleUrls: ['./apps-custom-price.component.scss'],
})
export class AppsCustomPriceComponent {
  orderItems: OrderConfirmationItem[];
  instantActivationItemSummaries: OrderConfirmationItem[] = [];
  activationItemSummaries: OrderConfirmationItem[] = [];
  @Input() productIsInstantBilledMap: Map<string, BillingStrategy>;
  @Input() userCanEditBillingInfo: boolean;
  @Input() stairStepOrderRequiresBilling: boolean;
  @Input() partnerId: string;
  @Input() billingInfoConfigured: boolean;
  @Input() submitDisabled: boolean;
  @Input() accountGroupId: string;
  @Input() hidePricing: boolean;
  @Input() editionsMap: AppIdToEditionIdToEditionMap;

  @Input()
  set orderConfirmationItems(orderItems: OrderConfirmationItem[]) {
    orderItems = orderItems || [];
    this.orderItems = orderItems.filter(
      (item) =>
        !item.priceOverride && item.appPrices.pricesForContexts['wholesale'].billingConfiguration.usesVariablePricing,
    );
    const instantBilledOrderItems = this.getBilledOrderItemsForStrategy(
      this.orderItems,
      this.productIsInstantBilledMap,
      BillingStrategy.Instantly,
    );
    this.instantActivationItemSummaries = this.buildActivationItemSummaries(instantBilledOrderItems, this.editionsMap);
    const nonInstantBilledOrderItems = this.orderItems.filter(
      (item) => !instantBilledOrderItems.find((i) => i.appId === item.appId && i.addonId === item.addonId),
    );
    this.activationItemSummaries = this.buildActivationItemSummaries(nonInstantBilledOrderItems, this.editionsMap);
  }

  buildActivationItemSummaries(
    orderItems: OrderConfirmationItem[],
    editionsMap: AppIdToEditionIdToEditionMap,
  ): OrderConfirmationItem[] {
    if (!orderItems?.length) {
      return [];
    }
    orderItems = orderItems.filter(
      (item) => item.appPrices.pricesForContexts['wholesale'].billingConfiguration.usesVariablePricing,
    );
    return orderItems.map((oi) => {
      if (this.orderConfirmationItemHasValidEditionId(oi)) {
        oi.editionName = editionsMap.get(oi.appId).get(oi.editionId).editionName;
      }
      return oi;
    });
  }
  orderConfirmationItemHasValidEditionId(item: OrderConfirmationItem): boolean {
    if (!item) {
      return false;
    }
    const { editionId, appId } = item;
    const itemHasValidEditionId = isValidEditionId(editionId);
    const editionsEntry = this.editionsMap.get(appId);
    const editionDataIsInEditionsMap = !!(editionsEntry && editionsEntry.get(editionId));
    return itemHasValidEditionId && editionDataIsInEditionsMap;
  }
  getBilledOrderItemsForStrategy(
    items: OrderConfirmationItem[],
    isInstantBilledMap: Map<string, BillingStrategy>,
    billingStrategy: BillingStrategy,
  ): OrderConfirmationItem[] {
    return (items || []).filter((item) => billingStrategy === isInstantBilledMap.get(item.addonId || item.appId));
  }
}
